export const CLOUDFUNCTION_URL = 'https://us-central1-wg-finances.cloudfunctions.net/';
